import React from 'react';
import {useTranslation} from 'react-i18next';
import QuotationMarks from '../assets/comillas@2x.png';
import XimenaPhoto from '../assets/ximena.png';
export default function Testimonial(){const {t}=useTranslation();return <section className="testimonial-section px-4 py-12" aria-label="Experiencia de clientes">        <figure className="relative mt-14 max-w-3xl mx-auto text-left bg-gradient-to-br from-[#f0f7ff] via-white to-[#e8f4fd] rounded-3xl border border-slate-100 shadow-[0_18px_50px_rgba(15,32,74,0.08)] p-8 md:p-10">
          <img
            src={QuotationMarks}
            alt=""
            aria-hidden="true"
            className="absolute -top-5 -left-2 w-12 h-12 opacity-80"
          />
          <blockquote className="text-slate-700 text-base md:text-lg leading-relaxed italic">
            “{t('testimonial.quote')}”
          </blockquote>
          <figcaption className="flex items-center gap-4 border-t border-slate-100 pt-6 mt-6">
            <img
              src={XimenaPhoto}
              alt=""
              loading="lazy"
              decoding="async"
              className="w-14 h-14 rounded-full object-cover ring-2 ring-blue-100"
            />
            <div>
              <p className="font-bold text-slate-900 text-base">{t('testimonial.name')}</p>
              <p className="text-sm text-blue-700 font-medium">{t('testimonial.role')}</p>
            </div>
          </figcaption>
        </figure></section>;}
